import { render, staticRenderFns } from "./ProductPreview.vue?vue&type=template&id=46d836a8&scoped=true"
import script from "./ProductPreview.vue?vue&type=script&lang=ts"
export * from "./ProductPreview.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ProductPreview.vue?vue&type=style&index=0&id=46d836a8&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "46d836a8",
  null
  ,true
)

export default component.exports